import { IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { IMediaAttachments } from '../../pages/ΟΑ/Tekmirio/types';
import DescriptionIcon from '@mui/icons-material/Description';
import Theme from '../../Themes/main.theme';
import { downloadFileFullPath } from '../../lib/helperFuncs';
import { Box } from '@mui/system';

interface IAttachments {
    attachments: IMediaAttachments[],
    direction?: 'row' | 'column'
}

const Attachments = ({ attachments, direction = 'row'}: IAttachments) => {
  const matchesLGbreakpoint = useMediaQuery('(max-width:1550px)');

  const oppositeDirection: "row" | "column" = direction === 'row'
    ? 'column'
    : 'row';

  const boxProps = {
    display: 'flex',
    flexDirection: { lg: direction, xs: oppositeDirection },
    alignItems: direction === 'column'
      ? { lg: 'start' }
      : 'center',
    columnGap: 3,
    flexWrap: { xs: 'wrap' as any, md: 'nowrap' as any }
  };

  const innerBoxProps = {
    ...(direction === 'column' && {
      display: { lg: 'flex' },
      alignItems: { lg: 'center' }
    })
  };

  const typographyEllipsisProps = {
    ...(matchesLGbreakpoint && {
      maxWidth: '100px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    })
  };

  return (
    <>
      <Box {...boxProps}>
        {attachments.map((attachment: IMediaAttachments) => {
          return (
            <>
              <Box id='attachments' {...innerBoxProps} >
                <Tooltip title={attachment.fileName}>
                  <Box display='flex' justifyContent='center'>
                    <IconButton aria-label='file' sx={{'&:hover': { backgroundColor: 'transparent' }, display: 'flex' }}
                      onClick={() => downloadFileFullPath(attachment.url)}>
                      <DescriptionIcon fontSize='inherit' sx={{width: 60, height: 60, marginX: 'auto' }} />
                    </IconButton>
                  </Box>
                </Tooltip>
                <Box display='flex' justifyContent='center'>
                  <Typography 
                    variant='h5'
                    color={Theme.labelColor?.main}
                    sx={typographyEllipsisProps}
                  >
                    {attachment.fileName}
                  </Typography>
                </Box>
                <Box display='flex' justifyContent='center'>
                  <Typography variant='h5' color={Theme.labelColor?.main}>
                    {attachment.size}
                  </Typography>
                </Box>
              </Box>
            </>
          );
        })}
      </Box>
    </>
  );
};

export default Attachments;